import { type AggregationFn } from "@tanstack/react-table";
import { differenceInMonths, isValid, parseISO } from "date-fns";

/**
 * NOTE: This function is called `range` because we want it to show up as `range` in the DataGrid
 * UI, and that is determined by the `name` field of the function.
 */
export const range: AggregationFn<unknown> = (columnId, leafRows) => {
	let minDate: Date | undefined;
	let maxDate: Date | undefined;
	leafRows.forEach((row) => {
		const value = row.getValue(columnId);
		if (typeof value !== "string") {
			return;
		}

		try {
			const date = parseISO(value);
			if (!minDate || date < minDate) {
				minDate = date;
			}
			if (!maxDate || date > maxDate) {
				maxDate = date;
			}
		} catch (e) {
			return;
		}
	});
	if (!minDate || !maxDate || !isValid(minDate) || !isValid(maxDate)) {
		return "";
	}

	return `${differenceInMonths(maxDate, minDate)} months`;
};
